<template>
	<nk-page commercialAccess="System" :policyClaims="['Settings_General_FiscalPeriod']">
		<template #badges v-if="localSettings.loadFromRemote">
			<nk-badge system="accounting">
				<nk-badge-item type="system" modelValue="accounting" :title="$t(`setting.title`)"></nk-badge-item>
				<nk-badge-item type="system" modelValue="accounting" :title="$t(`setting.fiscalPeriodSettings.title`)"></nk-badge-item>
			</nk-badge>
		</template>

		<div class="container-fluid h-100 ">
			<div class="nk-card" ref="settingFiscal">
				<div class="row">
					<div class="col-12">
						<nk-col-form-group :label="$t('setting.fiscal.f.TransferAccountsToNextPeriod') + ':'"  :labelSizes="{ sm: 3 }" :dataSizes="{ sm: 1 }">
							<nk-switch v-model="localData.fiscalPeriodSettings.transferAccountsToNextPeriod" :tabindex="101" startup></nk-switch>
						</nk-col-form-group>
					</div>
					<div class="col-12">
						<nk-col-form-group :label="$t('setting.fiscal.f.TransferCentersToNextPeriod') + ':'" :labelSizes="{ sm: 3 }" :dataSizes="{ sm: 1 }">
							<nk-switch v-model="localData.fiscalPeriodSettings.transferCentersToNextPeriod" :tabindex="102"></nk-switch>
						</nk-col-form-group>
					</div>
				</div>
			</div>
		</div>
	</nk-page>
</template>
<script>
	import _ from 'lodash'
	import $sc from '~/plugins/shortcut.collection.js'
	import { post } from '~/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'
	export default {
		props: {
			data: {},
			options: {},
		},
		modal: {
			helpTag: 'SettingsFiscalPeriod'
		},
		data() {
			return {
				settings: {
					loadFromRemote: true,
				},
				defaultData: {
					fiscalPeriodSettings: {
						transferCentersToNextPeriod: false,
						transferAccountsToNextPeriod: false,
					},
				},
				remoteData: null,
				saveFPSettingsButton: {
					title: this.$t('save'),
					shortcut: $sc.find('save'),
					isPrimary: false,
					icon: 'save',
					handle: (button, page, e) => {
						e.preventDefault()
						this.saveSettings()
					},
					policyClaims: 'Settings_General_FiscalPeriodEdit',
				},
			}
		},
		computed: {
			localSettings() {
				return _.extend({}, this.settings, this.options)
			},
			localData() {
				if (this.localSettings.loadFromRemote) {
					return this.remoteData
				} else {
					return this.data || this.defaultData
				}
			},
		},
		created() {
			if (this.localSettings.loadFromRemote) {
				this.remoteData = this.defaultData
			}
		},
		mounted() {
			this.getSetting()
			this.prepareWindow(this.$t('setting.fiscalPeriodSettings.title'), [
				this.saveFPSettingsButton,
			])
		},
		methods: {
			getSetting() {
				var wait = this.$wait(this.$refs.settingFiscal)
				var that = this

				post(Endpoints.getUrl('settings.get'), null, null, { preventConcurrent: false })
					.then((result) => {
						wait.end()
						that.remoteData = result.data
					})
					.catch(() => {
						wait.end()
					})
			},
			saveSettings() {
				var wait = this.$wait(this.grandParent)
				var that = this
				that.localData.type = 'FiscalPeriod'

				post(Endpoints.getUrl('settings.modify'), that.localData)
					.then((result) => {
						wait.end()
						let body = result.message ? result.message : this.$t('msg.create-success')
						this.$toast(body, { type: 'success' })

						// closes form if it's modal
						if (this.grandParentType() === 'modal')
							this.resolve()
					})
					.catch(() => {
						wait.end()
					})
			},
		},
	}
</script>
<style></style>
